<template>
  <div class="all_part">
    <div style="height: 212px" class="head">
      <div class="Logo">
        <img style="width: 300px" src="../assets/logo-white.png" alt="" />
      </div>
    </div>
    <div class="centerS">
      <div class="back_button">
        <div class="back" @click="back">
          <span>返回上一层</span>
        </div>
      </div>
      <div class="main_button">
        <div class="JiaGeKuCun">
          <div
              class="button"
              @click="PushJiaGe"

          >
            <img
                src="../assets/classButton-2.png"
                alt=""
                width="70px"
            />
            <span>标准报价库存查询</span>
          </div>
          <div
              class="button"
              @click="ShiChangXinXi"

          >
            <img
                src="../assets/classButton-1.png"
                alt=""
                width="70px"
            />
            <span>非标报价库存查询</span>
          </div>
        </div>
      </div>
    </div>

    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_leave: {},
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    back() {
      this.$router.push("/Main_menuComputer");
    },
    PushJiaGe() {
      this.$router.push("/productTable");
    },
    // PushJiaGe(){
    //   this.$router.push("/productTable");
    // },
    ShiChangXinXi() {
      this.$router.push("/FeiBiaoZhunChaXun");
    },
    PushRenWu() {
      this.$router.push("/productTable");
    },
    PushCaiWu() {
      this.$router.push("/productTable");
    },
  },
};
</script>

<style>
</style>
<style scoped>
.centerS {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-image: url("../assets/homeBackground.png");
  background-position: right bottom;
  background-size: 65% auto;
  background-repeat: no-repeat;
}
.all_part {
  min-height: 925px;
  min-width: 1920px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}
.head {
  display: flex;
  justify-content: center;
  background: #18a575;
}
.main_button {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 45%;
  margin-top: 120px;
}
.JiaGeKuCun {
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  width: 50%;
}
.Logo {
  margin-top: 30px;
}
.button {
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
}

.button img {
  width: 110px;
}

.button span {
  font-weight: 600;
  color: #18a575;
  font-size: 20px;
  margin-top: 10px;
}
.Copyright_information {
  margin-bottom: 15px;
}
.back_button {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 30px;
}
.back {
  border: #18a575 1px solid;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 40px;
  align-items: center;
  border-radius: 25px;
  color: #18a575;
  width: 120px;
  margin-right: 30px;
}
</style>
